export var OnuScreens;
(function (OnuScreens) {
    OnuScreens["DASHBOARD"] = "dashboard";
    OnuScreens["MAP"] = "map";
    OnuScreens["FACILITIES"] = "facilities";
    OnuScreens["ALERTS"] = "alerts";
    OnuScreens["WORKSPACES"] = "workspaces";
    OnuScreens["TOOLS"] = "tools";
    OnuScreens["INCIDENTS"] = "incident management";
    OnuScreens["PUMP_STATIONS"] = "pump stations";
    OnuScreens["DATA"] = "data";
    OnuScreens["ADMIN"] = "admin";
})(OnuScreens || (OnuScreens = {}));
export var AssetScreens;
(function (AssetScreens) {
    AssetScreens["NETWORK"] = "network";
    AssetScreens["TASKS"] = "tasks";
    AssetScreens["RISK"] = "risk";
    AssetScreens["REHAB"] = "rehab";
    AssetScreens["DATA"] = "data";
    AssetScreens["ADMIN"] = "admin";
})(AssetScreens || (AssetScreens = {}));
export const AssetScreenMapping = {
    '/map': AssetScreens.NETWORK,
    '/inspections': AssetScreens.TASKS,
    '/risk': AssetScreens.RISK,
    '/rehab': AssetScreens.REHAB,
    '/data': AssetScreens.DATA,
    '/admin': AssetScreens.ADMIN,
};
export const OnuScreenMapping = {
    '/': OnuScreens.DASHBOARD,
    '/map': OnuScreens.MAP,
    '/facilities': OnuScreens.FACILITIES,
    '/alerts': OnuScreens.ALERTS,
    '/workspace': OnuScreens.WORKSPACES,
    '/incident-management': OnuScreens.INCIDENTS,
    '/pump-station': OnuScreens.PUMP_STATIONS,
    '/data': OnuScreens.DATA,
    '/admin': OnuScreens.ADMIN,
    '/tools': OnuScreens.TOOLS,
    '/analytic': OnuScreens.TOOLS,
    '/massbalance': OnuScreens.TOOLS,
    '/ili': OnuScreens.TOOLS,
    '/pattern': OnuScreens.TOOLS,
    '/kpi': OnuScreens.TOOLS,
    '/demand-forecast': OnuScreens.TOOLS,
    '/assistant': OnuScreens.TOOLS,
};
